import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { HelpPageUserDto, TowerGroupDto } from 'src/app/api/models';
import { BookingHelperService } from 'src/shared/services/helpers/booking-helper.service';
import { IconComponent } from "../../elements/icon/icon.component";
import { IonButton } from "@ionic/angular/standalone";
import { TranslatePipe } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { SafeHtmlPipe } from 'src/shared/pipes/safe-html.pipe';

@Component({
  selector: 'vl-context-help-details',
  templateUrl: './context-help-details.component.html',
  styleUrls: ['./context-help-details.component.scss'],
  imports: [IonButton, IconComponent, TranslatePipe, NgIf, SafeHtmlPipe],
})
export class ContextHelpDetailsComponent  implements OnInit {
  @Input() helpPage: HelpPageUserDto;
  @Input() hidePrevious: boolean;
  @Input() hideNext: boolean;
  @Input() showContactUs: boolean;
  @Input() group: TowerGroupDto;
  @Input() pageView: 'web' | 'mobile';
  @Output() back: EventEmitter<any> = new EventEmitter<any>();
  @Output() prev: EventEmitter<any> = new EventEmitter<any>();
  @Output() next: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private modalCtrl: ModalController,
    private bookingHelper: BookingHelperService,
  ) { }

  ngOnInit() {}

  close() {
    this.modalCtrl.dismiss();
  }

  showList() {
    this.back.emit();
  }

  previousPage(id: number) {
    this.prev.emit(id);
  }

  nextPage(id: number) {
    this.next.emit(id);
  }

  async openSupport() {
		await this.bookingHelper.openSupport(this.group);
	}
}
